import { RouterEnum } from '@interface/public';
import RE from '@module/regexp';

/**
 * 配置
 */
export default class Config {
  public static readonly Cookie = { // Cookie
    domain: RE.Format.IPV4.test(location.hostname) // 域名
      ? ''
      : location.hostname.split('.').slice(-2).join('.'),
    time: 24 * 7 // SSO保存时间（小时）
  };
  public static readonly Console = { // 控制台
    log: '/////-' // 日志
  };
  public static readonly Href = { // 链接
    ...(
      $ENV.isFormal
        ? { // 正式服
          sso: 'https://sso.galaxy-future.com', // SSO
          official: 'https://www.galaxy-future.com', // 官网
          store: 'https://apps.galaxy-future.com', // 云应用市场
          cloud: 'https://cloud.galaxy-future.com', // 云托管平台
          cloudDemo: 'https://ifs.galaxy-future.com', // 云托管平台（Demo）
          console: 'https://console.galaxy-future.com', // Console
          dtexpress: 'https://dtexpress.galaxy-future.com', // 数据物流
          activity: 'https://activity.galaxy-future.com', // Activity
          aiavatars:'https://aiavatars-monn34rc.apps.galaxy-future.com/', // AI互动数字人
        }
        : { // 测试服
          sso: 'http://172.16.16.180:30081', // SSO
          official: 'http://172.16.16.180:30080', // 官网
          store: 'http://172.16.16.180:30090', // 云应用市场
          cloud: 'http://172.16.16.180:30092', // 云托管平台
          cloudDemo: 'http://172.16.16.180:18080', // 云托管平台（Demo）
          console: 'http://172.16.16.180:32003', // Console
          dtexpress: 'http://172.16.16.180:32094', // 数据物流
          activity: 'http://172.16.16.180:30082',  // Activity
          aiavatars:'https://aiavatars-test01.bridgx.cn/' // AI互动数字人
        }
    ),
    gss: 'https://gss.galaxy-future.com/#/cost/analysis', // GSS
    github: 'https://github.com/galaxy-future/infrapilot' // Github
  };
  public static readonly Template = { // 模板
    default: RouterEnum.Home, // 默认页面
    size: 'small', // 尺寸
    pagination: { // 分页
      pageSize: 10
    }
  };
}